'use client'

import { useGetMeService } from '@/api/@queries/users/use-get-me'
import { useAuth } from '@/hooks/use-auth'
import { Intercom } from '@intercom/messenger-js-sdk'
import { InitType } from '@intercom/messenger-js-sdk/dist/types'
import { useEffect } from 'react'
import { CookiesProvider } from 'react-cookie'
import { CookieToast } from '../react-cookie'

const APP_ID = process.env.NEXT_PUBLIC_INTERCOM_APP_ID || 'xw1kao5z'

export const ClientLayoutWrapper = ({
  children,
}: Readonly<{
  children: React.ReactNode
}>) => {
  const { token } = useAuth()

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }, [])

  let intercomProps = {
    app_id: APP_ID,
  } as InitType

  if (token) {
    const { data } = useGetMeService()

    const user = data?.data
    const userIdentifier = user?.id?.toString() || ''

    intercomProps = {
      app_id: APP_ID,
      user_id: userIdentifier,
      email: user?.email,
      name: user?.name || user?.company?.xNome,
      company: {
        id: user?.company?.id,
        name: user?.company?.xNome,
        created_at: user?.company?.created_at,
      },
    }
  }

  useEffect(() => {
    Intercom(intercomProps)
  }, [intercomProps])

  return (
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <CookieToast />
      {children}
    </CookiesProvider>
  )
}
